messenger.listen(messenger.topics.UPDATE_CART_BUBBLE, (itemCount) => {
  // console.log('receiving message update cart bubble: ', itemCount);
  const cartBubbleWrapper = document.querySelector('.cart-count-bubble');
  const cartBubble = document.querySelector('#item-count');
  const cartCount = document.querySelector('.cart-drawer__products');

  if (itemCount == 0) {
    cartCount.style.display = 'none';
    cartBubbleWrapper.style.display = 'none';
  } else if (itemCount >= 100) {
    cartCount.style.display = 'flex';
    cartCount.innerText = '99+';
    cartBubbleWrapper.style.display = 'flex';
    cartBubble.innerText = '99+';
  } else {
    cartCount.style.display = 'flex';
    cartCount.innerText = itemCount;
    cartBubbleWrapper.style.display = 'flex';
    cartBubble.innerText = itemCount;
  }
}, 'CartBubble');